import { useRef, useState } from 'react'
import { useClickAway } from 'react-use'

import sortIcon from 'assets/images/explore-learnings/sort.svg'
import { useExploreLearnings } from 'store/ExploreLearnings'

interface SortButtonProps {
  onChange: (value: string) => void
  options: { key: string; value: string }[]
}

export const SortButton = ({ onChange, options }: SortButtonProps) => {
  const [showSort, setShowSort] = useState(false)
  const sort = useExploreLearnings(state => state.sort)
  const selectRef = useRef(null)
  useClickAway(selectRef, () => {
    setShowSort(false)
  })
  return (
    <div className="relative  z-10" onClick={() => setShowSort(!showSort)} ref={selectRef}>
      <img src={sortIcon} alt="sort" />
      <div
        className={`${!showSort ? 'hidden' : 'flex'} flex-col p-2 absolute top-12 card-box-shadow -left-40 w-[196px] max-h-[156px] bg-white rounded-6`}
      >
        {options.map(el => (
          <button
            className={`w-full h-8 text-left px-2 py-[5px] rounded-6 mb-1 body-s ${el.value === sort ? 'font-semibold' : ''}`}
            key={el.value}
            onClick={() => {
              onChange(el.value)
            }}
          >
            {el.key}
          </button>
        ))}
      </div>
    </div>
  )
}
